// extracted by mini-css-extract-plugin
export var carrierIcon = "_y7-0";
export var carrierLogo = "_y7-1";
export var detailsSection = "_y7-2";